"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CustomerExperience = function CustomerExperience(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.3994 22.2996C10.3994 23.2385 11.1605 23.9997 12.0994 23.9997C13.0383 23.9997 13.7995 23.2385 13.7995 22.2996C13.7995 21.3607 13.0383 20.5996 12.0994 20.5996C11.1605 20.5996 10.3994 21.3607 10.3994 22.2996Z",
    fill: "#E6007E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.1992 22.2996C17.1992 23.2385 17.9603 23.9997 18.8992 23.9997C19.8381 23.9997 20.5993 23.2385 20.5993 22.2996C20.5993 21.3607 19.8381 20.5996 18.8992 20.5996C17.9603 20.5996 17.1992 21.3607 17.1992 22.2996Z",
    fill: "#E6007E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.75932 11.2752C7.74222 11.2239 7.72988 11.1704 7.72283 11.1152L7.02146 8.03917C6.91709 7.58146 7.20353 7.12582 7.66124 7.02146C8.11894 6.91709 8.57458 7.20353 8.67895 7.66124L9.24787 10.1564H18.8501C20.7483 10.1564 22.287 11.6951 22.287 13.5933C22.287 13.8509 22.258 14.1077 22.2006 14.3589L21.4259 17.7493C21.1584 18.9201 20.1169 19.7504 18.916 19.7504H11.7454C10.544 19.7504 9.50232 18.9195 9.23524 17.7482L7.75932 11.2752Z",
    fill: "#F7B3D8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.6355 11.8564L10.8927 17.3702C10.9835 17.7681 11.3373 18.0504 11.7454 18.0504H18.916C19.3239 18.0504 19.6777 17.7683 19.7686 17.3706L20.5433 13.9802C20.5723 13.8533 20.587 13.7235 20.587 13.5933C20.587 12.634 19.8094 11.8564 18.8501 11.8564H9.6355ZM9.6355 11.8564H8.56595C8.19045 11.8564 7.87181 11.6129 7.75932 11.2752C7.74222 11.2239 7.72988 11.1704 7.72283 11.1152C7.71828 11.0796 7.71593 11.0433 7.71593 11.0064C7.71593 10.5369 8.0965 10.1564 8.56595 10.1564H18.8501C20.7483 10.1564 22.287 11.6951 22.287 13.5933C22.287 13.8509 22.258 14.1077 22.2006 14.3589L21.4259 17.7493C21.1584 18.9201 20.1169 19.7504 18.916 19.7504H11.7454C10.544 19.7504 9.50232 18.9195 9.23524 17.7482L7.02146 8.03917C6.91709 7.58146 7.20353 7.12582 7.66124 7.02146C8.11894 6.91709 8.57458 7.20353 8.67895 7.66124L9.6355 11.8564Z",
    fill: "#E6007E"
  }));
};

CustomerExperience.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
CustomerExperience.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = CustomerExperience;
exports.default = _default;